export default __webpack_public_path__ + "static/media/56.d63f2778.jpeg";